import { FC } from "react";
import { useParams } from "react-router-dom";
import { Loader } from "@dune/ui";
import { TabLayoutErrorSkeleton } from "../../../component/layout/PageLayoutWithTabs";
import { useGetConstructionSiteDetails } from "../../../api/queries/constructionSite.queries";
import { CommonProjectForm } from "./CommonProjectForm";

export const EditProjectForm: FC = () => {
	const { id: projectId } = useParams<{ id: string }>();
	if (!projectId) {
		throw new Error("Project ID is required");
	}

	const { data: constructionSiteFullDetails, isLoading } =
		useGetConstructionSiteDetails(projectId);

	if (isLoading) {
		return <Loader />;
	}

	if (!isLoading && !constructionSiteFullDetails) {
		return (
			<TabLayoutErrorSkeleton message="Erreur lors du chargement des informations du projet." />
		);
	}

	return (
		<CommonProjectForm
			projectId={projectId}
			projectType="construction-site"
			constructionSiteFullDetails={constructionSiteFullDetails}
		/>
	);
};
